import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { CheckInService } from "../api";

export const actionGetInfo = createAsyncThunk(
  "daily-check-in/info",
  async (_, { rejectWithValue }) => {
    try {
      const res = await CheckInService.doGetInfo();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionGetDailyCheckIn = createAsyncThunk(
  "daily-check-in/check-in",
  async (_, { rejectWithValue }) => {
    try {
      const res = await CheckInService.doGetDailyCheckIn();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

const checkInSlice = createSlice({
  name: "check_in",
  initialState: {
    info: {
      loading: false,
      data: null,
      error: "",
    },
    checkIn: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Info
      .addCase(actionGetInfo.pending, (state) => {
        state.info.loading = true;
      })
      .addCase(actionGetInfo.fulfilled, (state, action) => {
        state.info.loading = false;
        state.info.data = action.payload;
      })
      .addCase(actionGetInfo.rejected, (state, action) => {
        state.info.loading = false;
        state.info.data = action.payload;
        state.info.error = action.error.message || "Something went wrong";
      })
      // check in
      .addCase(actionGetDailyCheckIn.pending, (state) => {
        state.checkIn.loading = true;
      })
      .addCase(actionGetDailyCheckIn.fulfilled, (state, action) => {
        state.checkIn.loading = false;
        state.checkIn.data = action.payload;
      })
      .addCase(actionGetDailyCheckIn.rejected, (state, action) => {
        state.checkIn.loading = false;
        state.checkIn.data = action.payload;
        state.checkIn.error = action.error.message || "Something went wrong";
      });
  },
});

export default checkInSlice.reducer;
export const { actions, reducer } = checkInSlice;
